var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1PhotoCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53 23l-8-8H31l-8.08 8H11v35h53.94V23H53zM38 52a12 12 0 110-23.999A12 12 0 0138 52zm22-20h-6v-4h6v4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/H1_Photo_camera.3193df3d.svg";
export { SvgH1PhotoCamera as ReactComponent };